(function() {
    'use strict';

    /**
     * usage: <textarea ng-model="content" redactor></textarea>
     *
     *    additional options:
     *      redactor: hash (pass in a redactor options hash)
     *
     */

    var redactorOptions = {};

    angular.module('cp.redactor', [])
        .constant('redactorOptions', redactorOptions)
        .directive('redactor', ['$timeout', function($timeout) {
            return {
                restrict: 'A',
                require: 'ngModel',
                link: function(scope, element, attrs, ngModel) {

                    // Expose scope var with loaded state of Redactor
                    scope.redactorLoaded = false;

                    var updateModel = function updateModel(value) {
                            $timeout(function() {
                                scope.$apply(function() {
                                    ngModel.$setViewValue(value);
                                });
                            });
                        },
                        options = {
                            lang: 'ru',
                            replaceDivs: false,
                            plugins: ['table', 'fontcolor'],
                            changeCallback: updateModel,
                            minHeight: 200,
                            imageUpload: Routing.generate('api_upload_post_image_from_redactor'),
                            imageUploadParam: 'image',
                            imageDeleteCallback: function(url, image) {
                                console.log(url)
                            },
                            fileUpload: Routing.generate('api_upload_post_file_from_redactor'),
                            modalOpenedCallback: function(name) {
                                if (name == 'imageEdit') {
                                    var $image = $(this.observe.image);

                                    var width = $image.width(),
                                        height = $image.height(),
                                        inputWidth = $("#redactor-image-width"),
                                        inputHeight = $("#redactor-image-height");

                                    inputWidth.val(width);
                                    inputHeight.val(height);

                                    $("#redactor-image-width, #redactor-image-height").keyup(function(e) {
                                        if (/\D/g.test(this.value)) {
                                            this.value = this.value.replace(/\D/g, '');
                                        }

                                        if (this.id == 'redactor-image-width') {
                                            inputHeight.val(Math.round(this.value*(height/width)));
                                        } else {
                                            inputWidth.val(Math.round(this.value*(width/height)));
                                        }
                                    });

                                    this.image.buttonSave.on('click', $.proxy(function() {
                                        $image.css('width', inputWidth.val());
                                        $image.css('height', inputHeight.val());

                                        this.code.sync();
                                    }, this));
                                }
                            }
                        },
                        additionalOptions = attrs.redactor ?
                            scope.$eval(attrs.redactor) : {},
                        editor;
                    angular.extend(options, redactorOptions, additionalOptions);
                    
                    // put in timeout to avoid $digest collision.  call render()
                    // to set the initial value.
                    $timeout(function() {
                        editor = element.redactor(options);
                        ngModel.$render();
                    });

                    ngModel.$render = function() {
                        if(angular.isDefined(editor)) {
                            $timeout(function() {
                                element.redactor('code.set', ngModel.$viewValue || '');
                                scope.redactorLoaded = true;
                            });
                        }
                    };
                }
            };
        }]);
})();